module.exports = __webpack_public_path__ + "img/5days.dd88664d.svg";